import { differenceInSeconds, format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import React, { useEffect, useState } from 'react';
import { ReactComponent as Check } from "../../../../../assets/images/response/check.svg";
import { ReactComponent as Copy } from "../../../../../assets/images/response/copy.svg";
import { ReactComponent as Transfer } from "../../../../../assets/images/ticket/transfer.svg";
import DetailsComponent from '../../../../common/DetailsComponent/DetailsComponent';
import InfoModal from '../../InfoModal/InfoModal';
import ShareModal from '../../ShareModal/ShareModal';
import './ResponsePix.scss';

const ResponsePix = ({ data, event, pix }) => {
  const [buttonText, setButtonText] = useState('COPIAR CÓDIGO');
  const [isCopied, setIsCopied] = useState(false);
  const [timeLeft, setTimeLeft] = useState(14 * 60);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openInfoModal = () => setIsInfoModalOpen(true);

  const [formattedStartDate, setFormattedStartDate] = useState('');
  const [formattedEndDate, setFormattedEndDate] = useState('');
  useEffect(() => {
    if (event) {
      try {
        const startDate = parseISO(event.starts_at);
        const endDate = parseISO(event.ends_at);

        const formattedStart = format(startDate, 'dd MMM - yyyy • HH:mm', { locale: ptBR });
        const formattedEnd = format(endDate, 'dd MMM - yyyy • HH:mm', { locale: ptBR });

        setFormattedStartDate(formattedStart);
        setFormattedEndDate(formattedEnd);
      } catch (error) {
        console.error('Error parsing or formatting date:', error);
      }
    }
  }, [event]);

  const detailsData = [
    {
      title: "Já realizei minha compra via Pix, por quê ainda está pendente?",
      content: (
        <div>
          <p>Quando você efetua uma compra via Pix, tem 15 minutos para finalizar o pagamento e, durante esse período, seu pedido fica pendente enquanto aguardamos a confirmação do pagamento por parte do banco. Essa confirmação pode demorar alguns minutos.</p>
          <p>Caso o banco não nos confirme o recebimento, o pedido é automaticamente cancelado e encaminharemos uma mensagem para te avisar sobre o status. Os ingressos selecionados por você não ficam mais reservados e retornam para venda na página do evento imediatamente.</p>
        </div>
      )
    },
    {
      title: "Como faço para reemitir o QR Code do Pix?",
      content: (
        <div>
          <p><b>No momento, não é possível reemitir o QR Code do Pix.</b> Para gerar um novo código, é preciso que você faça uma nova compra.</p>
        </div>
      )
    }
  ];

  useEffect(() => {
    if (data?.created_at) {
      const createdAt = parseISO(data.created_at);
      const expirationTime = 15 * 60; // 15 minutes
      const now = new Date();
      const elapsedTime = differenceInSeconds(now, createdAt);
      const initialTimeLeft = Math.max(expirationTime - elapsedTime, 0);
      setTimeLeft(initialTimeLeft);

      const intervalId = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 0) {
            clearInterval(intervalId);
            openInfoModal();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [data, openInfoModal]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(pix?.pix?.copy_paste)
      .then(() => {
        setButtonText('COPIADO!');
        setIsCopied(true);
        setTimeout(() => {
          setButtonText('COPIAR CÓDIGO');
          setIsCopied(false);
        }, 2000);
      })
      .catch(err => {
        console.error('Erro ao copiar o texto: ', err);
      });
  };

  return (
    <section className="product-container">
      <div className="product-info">
        <div className="header-info">
          <div className="container-header">
            <p className='title'>Agora só falta concluir seu Pix!</p>
            <div className="description">
              <div className='image-pix'>
                <div>
                  <img src={pix?.pix?.qr_code} alt="Pix QRCODE" />
                  <p className='copy-paste'>{pix?.pix?.copy_paste}</p>
                </div>
                <button onClick={handleCopy} className={`copy-button ${isCopied ? 'copied' : ''}`} >{isCopied ? <Check /> : <Copy />}{buttonText}</button>
              </div>
              <div className="pending-pix">
                <div className="pending-pix-header">
                  <p className='title-header'><b>Como pagar?</b></p>
                  <div className="info-pending"><svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 16.3264C12 16.5916 11.8946 16.8459 11.7071 17.0335C11.5196 17.221 11.2652 17.3264 11 17.3264H9C8.73478 17.3264 8.48043 17.221 8.29289 17.0335C8.10536 16.8459 8 16.5916 8 16.3264C8 16.0611 8.10536 15.8068 8.29289 15.6192C8.48043 15.4317 8.73478 15.3264 9 15.3264H11C11.2652 15.3264 11.5196 15.4317 11.7071 15.6192C11.8946 15.8068 12 16.0611 12 16.3264ZM17 4.32635V16.3264C17 17.3872 16.5786 18.4046 15.8284 19.1548C15.0783 19.9049 14.0609 20.3264 13 20.3264H7C5.93913 20.3264 4.92172 19.9049 4.17157 19.1548C3.42143 18.4046 3 17.3872 3 16.3264V4.32635C3 3.26549 3.42143 2.24807 4.17157 1.49793C4.92172 0.747782 5.93913 0.326355 7 0.326355L13 0.326355C14.0609 0.326355 15.0783 0.747782 15.8284 1.49793C16.5786 2.24807 17 3.26549 17 4.32635ZM15 4.32635C15 3.79592 14.7893 3.28721 14.4142 2.91214C14.0391 2.53707 13.5304 2.32635 13 2.32635H7C6.46957 2.32635 5.96086 2.53707 5.58579 2.91214C5.21071 3.28721 5 3.79592 5 4.32635V16.3264C5 16.8568 5.21071 17.3655 5.58579 17.7406C5.96086 18.1156 6.46957 18.3264 7 18.3264H13C13.5304 18.3264 14.0391 18.1156 14.4142 17.7406C14.7893 17.3655 15 16.8568 15 16.3264V4.32635Z" fill="#848C9B"></path></svg><p>Abra o app do seu banco ou carteira digital e <b>escolha pagar com Pix</b></p></div>
                  <div className="info-pending"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 6.5V9.5H6.5V6.5H9.5ZM11 5H5V11H11V5ZM9.5 14.5V17.5H6.5V14.5H9.5ZM11 13H5V19H11V13ZM17.5 6.5V9.5H14.5V6.5H17.5ZM19 5H13V11H19V5ZM13 13H14.5V14.5H13V13ZM14.5 14.5H16V16H14.5V14.5ZM16 13H17.5V14.5H16V13ZM13 16H14.5V17.5H13V16ZM14.5 17.5H16V19H14.5V17.5ZM16 16H17.5V17.5H16V16ZM17.5 14.5H19V16H17.5V14.5ZM17.5 17.5H19V19H17.5V17.5ZM21 7C20.7348 7 20.4804 6.89464 20.2929 6.70711C20.1054 6.51957 20 6.26522 20 6V4H18C17.7348 4 17.4804 3.89464 17.2929 3.70711C17.1054 3.51957 17 3.26522 17 3C17 2.73478 17.1054 2.48043 17.2929 2.29289C17.4804 2.10536 17.7348 2 18 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V6C22 6.26522 21.8946 6.51957 21.7071 6.70711C21.5196 6.89464 21.2652 7 21 7ZM22 21V18C22 17.7348 21.8946 17.4804 21.7071 17.2929C21.5196 17.1054 21.2652 17 21 17C20.7348 17 20.4804 17.1054 20.2929 17.2929C20.1054 17.4804 20 17.7348 20 18V20H18C17.7348 20 17.4804 20.1054 17.2929 20.2929C17.1054 20.4804 17 20.7348 17 21C17 21.2652 17.1054 21.5196 17.2929 21.7071C17.4804 21.8946 17.7348 22 18 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21ZM3 22H6C6.26522 22 6.51957 21.8946 6.70711 21.7071C6.89464 21.5196 7 21.2652 7 21C7 20.7348 6.89464 20.4804 6.70711 20.2929C6.51957 20.1054 6.26522 20 6 20H4V18C4 17.7348 3.89464 17.4804 3.70711 17.2929C3.51957 17.1054 3.26522 17 3 17C2.73478 17 2.48043 17.1054 2.29289 17.2929C2.10536 17.4804 2 17.7348 2 18V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22ZM2 3V6C2 6.26522 2.10536 6.51957 2.29289 6.70711C2.48043 6.89464 2.73478 7 3 7C3.26522 7 3.51957 6.89464 3.70711 6.70711C3.89464 6.51957 4 6.26522 4 6V4H6C6.26522 4 6.51957 3.89464 6.70711 3.70711C6.89464 3.51957 7 3.26522 7 3C7 2.73478 6.89464 2.48043 6.70711 2.29289C6.51957 2.10536 6.26522 2 6 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V3Z" fill="currentColor"></path></svg><p>Selecione a opção <b>pagar com QR Code e escaneie o código </b>ao lado ou <b>copie o código e selecione a opção Pix Copia e Cola.</b>.</p></div>
                  <div className="info-pending"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 10.0222 2.58649 8.08879 3.6853 6.4443C4.78412 4.79981 6.3459 3.51809 8.17317 2.76121C10.0004 2.00433 12.0111 1.8063 13.9509 2.19215C15.8907 2.578 17.6725 3.53041 19.0711 4.92894C20.4696 6.32746 21.422 8.10929 21.8079 10.0491C22.1937 11.9889 21.9957 13.9996 21.2388 15.8268C20.4819 17.6541 19.2002 19.2159 17.5557 20.3147C15.9112 21.4135 13.9778 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12H2ZM4 12C4 13.5823 4.46919 15.129 5.34824 16.4446C6.22729 17.7602 7.47672 18.7855 8.93853 19.391C10.4003 19.9965 12.0089 20.155 13.5607 19.8463C15.1126 19.5376 16.538 18.7757 17.6569 17.6569C18.7757 16.538 19.5376 15.1126 19.8463 13.5607C20.155 12.0089 19.9965 10.4003 19.391 8.93854C18.7855 7.47673 17.7602 6.2273 16.4446 5.34825C15.129 4.4692 13.5823 4 12 4C9.87827 4 7.84344 4.84286 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12ZM9.5 11C9.42909 10.9133 9.3418 10.8415 9.24311 10.7885C9.14443 10.7356 9.03628 10.7026 8.92485 10.6915C8.81342 10.6803 8.70089 10.6912 8.59368 10.7236C8.48646 10.7559 8.38667 10.8091 8.3 10.88C8.21333 10.9509 8.14147 11.0382 8.08853 11.1369C8.0356 11.2356 8.00261 11.3437 7.99147 11.4552C7.98033 11.5666 7.99124 11.6791 8.02359 11.7863C8.05594 11.8935 8.10909 11.9933 8.18 12.08L10.28 14.66C10.3596 14.762 10.4624 14.8435 10.5799 14.8976C10.6975 14.9517 10.8263 14.9769 10.9555 14.971C11.0848 14.9652 11.2107 14.9284 11.3228 14.8639C11.435 14.7993 11.53 14.7088 11.6 14.6L15.8 10.31C15.8652 10.2175 15.9115 10.113 15.9362 10.0026C15.9609 9.89213 15.9636 9.77789 15.9441 9.66641C15.9246 9.55493 15.8833 9.44839 15.8225 9.35291C15.7617 9.25743 15.6827 9.17489 15.59 9.11C15.4999 9.04558 15.3978 8.99986 15.2897 8.97552C15.1816 8.95118 15.0698 8.94873 14.9607 8.9683C14.8517 8.98787 14.7477 9.02907 14.6548 9.08948C14.5619 9.14988 14.4821 9.22826 14.42 9.32L10.91 12.74L9.5 11Z" fill="#848C9B"></path></svg><p>Confirme as informações e finalize a compra</p></div>
                </div>
                <div className="pending-pix-time">
                  <p>Este código expira em </p>
                  <span className='time'>{formatTime(timeLeft)}</span>
                  <p> minutos e não será mais válido.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="helper-pix">
          <h4>Dúvidas frequentes sobre o Pix</h4>
          <div className="container-helper">
            {detailsData.map((item, index) => (
              <DetailsComponent
                key={index}
                title={item.title}
                content={item.content}
              />
            ))}
          </div>

          <div className="info-event">
            <div className="image-container">
              <img src={event.image_url} alt="Evento" />
            </div>
            <div className="data-event">
              <p className="title">
                {event.name}
              </p>
              <div>
                <div className="event-information-container">
                  <span className="mdi--clock-outline" />
                  <div>
                    <p className="title">
                      {formattedStartDate} - {formattedEndDate}
                    </p>
                  </div>
                </div>
                <div className="event-information-container">
                  <span className="carbon--location" />
                  <div>
                    <p className="title">
                      {`${event?.address?.street}, ${event?.address?.number} - ${event?.address?.neighborhood}, ${event?.address?.city} - ${event?.address?.state}`}
                    </p>
                  </div>
                </div>
                <button onClick={openModal}>
                  <Transfer />Compartilhe com seus amigos
                </button>
              </div>
            </div>
          </div>
        </div>
        <ShareModal event={event} isOpen={isModalOpen} onClose={closeModal} />
        <InfoModal
          event={event}
          title='O tempo para a compra expirou'
          content={<>Isso é necessário para que uma reserva não fique presa e possa estar disponível para compra novamente. <br />
          <strong>Caso tenha efetuado o pagamento, em breve você receberá um email de confirmação.</strong></>}
          isOpen={isInfoModalOpen}
        />
      </div>
    </section>
  )
}

export default ResponsePix
